export const VendorStatusConstants = {
    GET_ALL_VENDOR_STATUS_SUCCESS: "GET_ALL_VENDOR_STATUS_SUCCESS",
    GET_ALL_VENDOR_STATUS_ERROR: "GET_ALL_VENDOR_STATUS_ERROR",
    ALL_VENDOR_STATUS_LOADING: "ALL_VENDOR_STATUS_LOADING",
};
